












































































import Vue from 'vue'
import Component from 'vue-class-component'

import ConfigField from '../../../../components/ConfigField/ConfigField.vue'
import { errorNotificationWrapper } from '../../../../logic/helpers/NotificationService'
import PostApi from '../../includes/logic/Api/PostApi'
import RegexpReference from './RegexpReference.vue'

@Component({
  components: {
    ConfigField,
    RegexpReference,
  },
})
export default class RegexpValidator extends Vue {
  pattern = ''

  string = ''

  toLowercase = false

  resultString = ''

  referencePopup = false

  isLoading = false

  get isActivePlayButton(): string {
    return this.string && this.pattern
  }

  processResultString(string:string, regexpItems: any): string {
    if (regexpItems.length <= 0) {
      return string.replace(/\r|\n/g, '<br>')
    }

    let returnString = ''
    let fromIndex = 0
    for (const [ index, regexpItem ] of regexpItems.entries()) {
      returnString += string.slice(fromIndex, regexpItem.from)
        + this.backlight(string.slice(regexpItem.from, regexpItem.to))
      fromIndex = regexpItem.to
      if (index === regexpItems.length - 1) returnString += string.slice(fromIndex)
    }
    // eslint-disable-next-line require-unicode-regexp
    return returnString.replace(/\r|\n/g, '<br>')
  }

  backlight(string:string): any {
    return `<span style="background: #ffff00;">${ string }</span>`
  }

  async send(): Promise<void> {
    this.isLoading = true

    try {
      const response = await PostApi.sendRequest('tg', 'testregexp', {
        pattern: this.pattern,
        string: this.string,
        to_lower_case: this.toLowercase,
      })
      if (response) {
        this.resultString = this.processResultString(this.string, response.data.items)
      }
    } catch (error: any) {
      errorNotificationWrapper('', error)
    } finally {
      this.isLoading = false
    }
  }

  reset(): void {
    this.pattern = ''
    this.string = ''
    this.toLowercase = false
    this.resultString = ''
  }
}
